<template>
  <div>
    <!-- Main Form -->
    <FormulateForm #default="{ hasErrors }">
      <div class="flex flex-col gap-6">
        <!-- Dashboard Configuration -->
        <div>
          <h1 class="text-gray-700 font-semibold text-lg mb-3">
            {{ $t('pages.tenant_client.dashboard') }}
          </h1>
          <div class="grid grid-cols-2 gap-6">
            
            <!-- Dashboards Dropdown -->
            <div class="bg-white p-6 rounded-lg">
              <h2 class="mb-1 mt-1">
                {{ $t('pages.tenant_client.dashboard') }}
                <span class="text-red-500 ml-1 text-lg leading-3">*</span>
              </h2>
              <div v-if="loadingState.dashboards" class="flex items-center justify-center py-12">
                <Loader />
              </div>

              <div
        class="search_container flex items-center gap-4 flex-1 text-gray-500"
      >

        <Input
          class="flex-1"
          @input="(value) => handleDashboardFilter(value)"
          :placeholder="$t('components.lists.search')"
          icon="search"
        />
        </div>
         <div class="flex gap-3 w-full justify-between px-2 py-3">
      <div class="flex items-center gap-3 w-full">
        <!-- Empty space for checkbox and label area -->
      </div>
      <div class="flex items-center">
        <span class="text-sm font-medium text-gray-700">Default</span>
      </div>
    </div>
    <div class="bg-gray-100 rounded-2xl p-2">
                    <draggable   
                        v-model="dashboards"
                        @start="isDragging = true"
                        @end="stopDragging($event)"
                        @change="onReorder($event)"
                        :group="{ name: 'check', pull: 'clone', put: true }"
                        class="sortable-list"
                        :disabled="false"
                        :sort="true"
                        v-bind="dragOptions"
                    >
              <template>
                <div v-for="check in filteredDashboards" :key="check.id"
                            class="list-group-item child item"
                        >
                
        <div v-if="check.name" class="grid-parent-items-wrapper flex items-center gap-3 w-full">
            <font-awesome-icon icon="grip-vertical" 
                :class="check.selected ? 'text-gray-500' : 'text-gray-300 cursor-not-allowed'" 
                class="ml-2" />
            <div class="grid-parent-items-inner flex-1 transition-all duration-200 py-1 items-center gap-3 rounded-xl">
                <div class="w-full bg-white rounded-md mr-2">
                    <div class="w-full">
                        <div class="flex w-full gap-3 items-center justify-between text-sm p-2">
                          <input
                          :ref="`checkbox-${check.id}`"
                          :checked="check.selected"
                          type="checkbox"
                          @change="(event) => handleCheckboxChange(check, event)"
                          :id="`checkbox-${check.id}`"
                          class="checkbox cursor-pointer checkbox-primary border-box-stroke checkbox-sm flex"
                          />
                            <!-- Dashboard name -->
                            <div class="flex-1">
                                <span v-tippy :content="check.name"
                                    class="section_name bg-transparent border-0 outline-none p-1 text-md  font-semibold truncate"
                                    :class="check.selected ? 'text-base-content' : 'text-gray-400'">
                                    {{ check.name }}
                                </span>
                            </div>

                            <!-- Permissions button -->
                            <div class="flex justify-center">
                                <DropdownButton
                                    :title="$t('pages.workflow_engine.permissions')"
                                    @click="showGroupsModal(check)"
                                    :disabled="!check.selected"
                                />
                            </div>

                            <!-- Default radio button -->
                            <div class="flex items-center">
                                <input
                                  :ref="`radio-${check.id}`"
                                  :checked="check['is_default']"
                                  type="checkbox"
                                  :disabled = "!check.selected"
                                  @change="(event) => handleDefaultToggle(check, event)"
                                  :id="`radio-${check.id}`"
                                  class="radio-checkbox"
                                  :class="check.selected ? 'cursor-pointer' : 'cursor-not-allowed'"
                                />
                            </div>

                        </div>
                    </div>
                    
                
            </div>
        </div>


    </div>
    
    </div>
              </template>
              </draggable>
              </div>
            </div>

            <!-- Email Templates -->
            <div class="bg-white p-6 rounded-lg">
              <h2 class="mb-1 mt-1">
                {{ $t('pages.tenant_client.dashboard_notification_email_template') }}
                <span class="text-red-500 ml-1 text-lg leading-3">*</span>
              </h2>
              <div v-if="loadingState.emailTemplates" class="flex items-center justify-center py-12">
                <Loader />
              </div>
              <ListView
                v-else
                :listItems="filteredEmailTemplateList"
                @rowClick="handleCheckClick"
                :showSearch="true"
                :showCheckBox="true"
                :showRadio="true"
                radioGroupName="email-templates"
                radioKey="is_default"
                class="h-full overflow-y-auto"
                @handleFilterResult="handleFilterResult"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex my-4 w-full justify-between" v-if="disableAllField">
        <Button
          :text="$t('actions.back')"
          type="outline"
          @click="$emit('handleBackSection')"
        />
        <Button
          :loader="isFormSubmit"
          :text="isClientOnBoarded ? 'Save & Next' : 'Save and Onboard Client'"
          type="primary"
          @click="handleSubmit(hasErrors)"
        />
      </div>
    </FormulateForm>
    <PermissionDashboardController
            ref="permissions-controller"
            :disabled="!disableAllField"
            :groups= "dashboardusersGroups"
            :selected="selectedPermissionIds"
            :id="'Dashboard Assignment'"
            :checkDetails="selectedDashboard"
            :loading="false"
            :clientName="clientName"
            @submit="onPermissionGroupsSubmit"
        />
  </div>
</template>

<script>
import Button from "@shared/components/button";
import Input from "@shared/input";
import { Dropdown as DropdownButton } from "@shared/components/buttons";
// import Dropdown from "@shared/components/dropdown-base";
import Loader from "@shared/loader";
import ListView from "@shared/components/dashboard-list-view";
import draggable from 'vuedraggable';
import {
  getClientDashboards,
  getTenantDashboards,
  getEmailTempaltes,
  getClientEmailTemplate,
  getDashboardUsersAndGroups,
  clientGroups,
  clientUsers,
  updateGroupsUsers,
  getDashboardSortOptions,
  fetchClientInfo
} from "../services";
import { checkPermission } from "@shared/utils/functions";
import PermissionDashboardController from "@shared/components/PermissionDashboardController";


export default {
  name: "client-configuration",
  components: {
    Button,
    Loader,
    // Dropdown,
    ListView,
    DropdownButton,
    Input,
    draggable,
    PermissionDashboardController,
    // DashboardAssignmentModal
  },
  props: {
    clientDetails: Object,
    loadingStates: Object,
  },
  data() {
    return {
      configuration: {
        dashboards: [],
        dashboard_email_templates: [],
      },
      dashboardDetails: [],
      loadingState: {
        client: false,
      },
      clientId: null,
      dashboards: [],
      dashboard_email_templates: [],
      searchFilter: '',
      dashboardSearchFilter: '',
      isDragging: false,
      disableCheckbox: false,
      showDashboardModal: false,
      selectedDashboard: null,
      selectedPermissionIds: [],
      users: [],
      groups: [],
      dashboardusersGroups: null,
      clientName: null,
    };
  },
  computed: {
    isClientOnBoarded() {
      return this.clientDetails?.onboarded || false;
    },
    isFormSubmit() {
      return this.loadingStates?.formSubmit || false;
    },
    isAllSelected() {
      return  "#0D69D5";
    },
    disableAllField() {
      const route = this.$route.name;
      const onboarded = this.isClientOnBoarded;
      if (route === "client-details") {
        return onboarded
          ? checkPermission("client.edit")
          : checkPermission("client.create");
      }
      return false;
    },

   

    isCheckboxDisabled() {
      return this.disableCheckbox;
    },
    
    dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    filteredDashboards() {
      const filtered = this.dashboards.map(dashboard => {
        const isSelected = this.configuration.dashboards.some(d => d.id === dashboard.id);
        const configDashboard = this.configuration.dashboards.find(d => d.id === dashboard.id);
        return {
          ...dashboard,
          selected: isSelected,
          is_default: configDashboard?.is_default || dashboard.is_default || false,
          order: configDashboard?.order || null
        };
      });

      let result = filtered;
      if (this.dashboardSearchFilter) {
        result = filtered.filter(dashboard => 
          dashboard.name.toLowerCase().includes(this.dashboardSearchFilter.toLowerCase())
        );
      }
      
      // Sort: dashboards with order first (sorted by order), then dashboards without order
      return result.sort((a, b) => {
        if (a.order === null && b.order === null) return 0;
        if (a.order === null) return 1;
        if (b.order === null) return -1;
        return a.order - b.order;
      });
    },
    dropdownColors() {
      return {
        text: "#282828",
        bg: "white",
        svg: "#282828",
        border: "#bcbcbc",
      };
    },
    filteredEmailTemplateList() {
      const filtered = this.dashboard_email_templates.filter((template) => {
        if (!this.searchFilter) return true;
        return template.name?.toLowerCase().includes(this.searchFilter.toLowerCase());
      });
      
      return filtered.map((template) => {
        const selected = this.configuration.dashboard_email_templates.find(
          (t) => t.id === template.id
        );
        return {
          ...template,
          checked: !!selected,
          is_default: selected?.is_default || false,
        };
      });
    },
  },
  async mounted() {
    await this.getClientDetails();
    await this.getUsersAndGroups();
  },
  methods: {
    async getClientDetails() {
      this.loadingState.client = true;
      this.clientId = this.$route.params.clientId;
      const  clientDetails  = await fetchClientInfo(this.clientId)
      this.clientName = clientDetails.name;
      await Promise.all([
        this.getAvailableDashboards(),
        this.getAvailableEmailTemplates(),
      ]);

      if (this.clientId) {
        this.configuration = {
          dashboards: [],
          dashboard_email_templates: [],
        };
          this.loadClientDashboards(),
          this.loadClientEmailTemplates()
        
      }

      this.loadingState.client = false;
    },
    handleCheckboxChange(dashboard, event) {
      const isChecked = event.target.checked;
      
      if (isChecked) {
        // Add dashboard to configuration if not exists
        const exists = this.configuration.dashboards.find(d => d.id === dashboard.id);
        if (!exists) {
          // Get max order from existing dashboards with order
          const maxOrder = this.configuration.dashboards
            .filter(d => d.order !== null)
            .reduce((max, d) => Math.max(max, d.order || 0), 0);
          
          this.configuration.dashboards.push({ 
            ...dashboard, 
            selected: true,
            order: maxOrder + 1
          });
        }
      } else {
        // Remove dashboard from configuration and unset default
        this.configuration.dashboards = this.configuration.dashboards.filter(
          d => d.id !== dashboard.id
        );
        
        // Also unset is_default when dashboard is unchecked
        const selectedDashboard = this.dashboards.find(d => d.id === dashboard.id);
        if (selectedDashboard) {
          selectedDashboard.is_default = false;
        }
      }
    },

    handleDefaultToggle(dashboard, event) {
      const isChecked = event.target.checked;
      
      // Update the is_default state
      const selectedDashboard = this.dashboards.find(d => d.id === dashboard.id);
      if (selectedDashboard) {
        selectedDashboard.is_default = isChecked;
      }
      
      const configDashboard = this.configuration.dashboards.find(d => d.id === dashboard.id);
      if (configDashboard) {
        configDashboard.is_default = isChecked;
      }
    },

    
    closeDashboardModal() {
      this.showDashboardModal = false;
    },

    async getUsersAndGroups() {
      try {
        // Fetch client users
        const usersResponse = await clientUsers(this.clientId)
        this.users = usersResponse;
        
        // Fetch groups
        const groupsResponse = await clientGroups(this.clientId);
        this.groups = groupsResponse;
      } catch (error) {
        console.error('Failed to fetch users and groups:', error);
      }
    },

    async getDashboardGroups(dashboardId) {
      try {
        const response = await getDashboardUsersAndGroups(dashboardId, this.clientId);
        const dashboardData = response.data.data;
        // Get selected user IDs from dashboard data
        const selectedUserIds = dashboardData?.users;
        
        // Get selected group IDs from dashboard data
        const selectedGroupIds = dashboardData?.groups;
        
        this.users = this.users.map(user => ({
          ...user,
          selected: selectedUserIds.includes(user.id)
        }));
        
        // Update this.groups with selected property
        this.groups = this.groups.map(group => ({
          ...group,
          selected: selectedGroupIds.includes(group.id)
        }));
        
        // Map users with their details
        
        this.dashboardusersGroups = {
          users: this.users,
          client: this.groups
        };
        
        // Set selected permission IDs for the modal
        this.selectedPermissionIds = [
          ...selectedUserIds,
          ...selectedGroupIds
        ];
        
      } catch (error) {
        console.error('Failed to fetch dashboard permissions:', error);
      }
    },

    async onPermissionGroupsSubmit(selectedIds) {
      this.selectedPermissionIds = selectedIds;
      try {
        const selectedUserIds = this.users
          .filter(user => this.isSelectedModifier(user, selectedIds))
          .map(user => user.id);
        
        const selectedGroupIds = this.groups
          .filter(group => this.isSelectedModifier(group, selectedIds))
          .map(group => group.id);
        
        const payload = {
          users: selectedUserIds,
          groups: selectedGroupIds
        };
        
        await updateGroupsUsers(this.selectedDashboard.id, this.clientId, payload);
        
        this.$refs["permissions-controller"]?.hideModal();
      } catch (error) {
        console.error('Failed to save permissions:', error);
      }
    },
        isSelectedModifier(el, selected = this.selectedPermissionIds) {
            return selected.includes(el.id) || selected.includes(el.group_id) || selected.includes(el.user_id);
        },

    async showGroupsModal(check) {
        this.selectedDashboard = check;
        await this.getDashboardGroups(this.selectedDashboard?.id)
        this.$refs["permissions-controller"]?.showModal();
    },
    startDragging() {
            this.isDragging = true;
    },
    stopDragging() {
        this.isDragging = false;
    },
     handleSelectAll() {
      if (this.isCheckboxDisabled) return;
      this.checkAllSelected = !this.checkAllSelected;
      this.$emit("handleSelect", this.selectAll);
    },

    async onReorder(e) {
      if (e.moved) {
        const oldIndex = e.moved.oldIndex;
        const newIndex = e.moved.newIndex;
        
        // Update configuration.dashboards order
        const movedItem = this.configuration.dashboards.splice(oldIndex, 1)[0];
        this.configuration.dashboards.splice(newIndex, 0, movedItem);
        
        // Update order property in configuration dashboards
        this.configuration.dashboards.forEach((item, index) => {
          item.order = index + 1;
        });
        
        // Prepare payload for API
        const dashboardIds = this.configuration.dashboards.map(item => item.id);
        const payload = {
          client_id: this.clientId,
          order: dashboardIds
        };
        
        await getDashboardSortOptions(payload);
      }
    },
        

    async getAvailableDashboards() {
      const res = await getTenantDashboards();
      this.dashboards = res?.data?.dashboards || [];
    },

    async getAvailableEmailTemplates() {
      const { data } = await getEmailTempaltes(this.$store.getters.getTenantId);
      this.dashboard_email_templates = (data?.content || []).filter(
        (item) => !item.content
      );
    },

    async loadClientDashboards() {
      const res = await getClientDashboards(this.clientId);
      const clientDashboards = res?.data?.dashboards || [];
      
      // Set configuration dashboards
      this.configuration.dashboards = this.dashboards.filter((d) =>
        clientDashboards.some((cd) => cd.id === d.id)
      ).map((d) => {
        const clientDashboard = clientDashboards.find((cd) => cd.id === d.id);
        return {
          ...d,
          is_default: clientDashboard?.is_default || false,
          order: clientDashboard?.order || null
        };
      });
      
      // Reorder this.dashboards to show client dashboards first
      const clientDashboardIds = clientDashboards.map(cd => cd.id);
      const clientDashboardsFromAll = this.dashboards.filter(d => clientDashboardIds.includes(d.id));
      const nonClientDashboards = this.dashboards.filter(d => !clientDashboardIds.includes(d.id));
      
      this.dashboards = [...clientDashboardsFromAll, ...nonClientDashboards];
    },

    async loadClientEmailTemplates() {
      const res = await getClientEmailTemplate(this.clientId);
      const templates = res?.data?.content || [];

      this.configuration.dashboard_email_templates = templates
        .map((t) => {
          const match = this.dashboard_email_templates.find((d) => d.id === t.id);
          return match ? { ...t, is_default: t.system_default || false } : null;
        })
        .filter(Boolean);
    },

    handleSubmit(hasErrors) {
      if (hasErrors) {
        return this.$toast.error(this.$t('pages.tenant_client.please_fill_all_the_required_fields'));
      }
      if (!this.configuration.dashboards.length) {
        return this.$toast.error(this.$t('pages.tenant_client.please_select_a_dashboard'));
      }
      if (!this.configuration.dashboard_email_templates.length) {
        return this.$toast.error(this.$t('pages.tenant_client.please_select_a_email_template'));
      }
      
      const dashboards = this.configuration.dashboards
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map((d) => {
          const mainDashboard = this.dashboards.find(dash => dash.id === d.id);
          return {
            ...mainDashboard,
            is_default: d.is_default || false,
            order: d.order
          };
        });
      
      const dashboard_email_templates = this.configuration.dashboard_email_templates.map((t) => {
        const mainTemplate = this.dashboard_email_templates.find(template => template.id === t.id);
        return {
          ...mainTemplate,
          is_default: t.is_default || false
        };
      });

      const payload = {
        data: {
          ...this.configuration,
          dashboards,
          dashboard_email_templates,
        },
      };

      this.$emit("submitForm", payload);
    },

    handleCheckClick({ row, value, radio }) {
      if (value !== undefined) {
        const exists = this.configuration.dashboard_email_templates.find((t) => t.id === row.id);
        if (value && !exists) {
          this.configuration.dashboard_email_templates.push({ id: row.id });
        } else if (!value) {
          this.configuration.dashboard_email_templates = this.configuration.dashboard_email_templates.filter(
            (t) => t.id !== row.id
          );
        }
      }

      if (radio !== undefined) {
        this.configuration.dashboard_email_templates.forEach((t) => {
          t.is_default = t.id === row.id;
        });
      }
    },

    

    setTenantDashboards(value) {
      console.log("Dashboards selected:", value);
    },

    setTenantEmailTemplate(value) {
      console.log("Email templates selected:", value);
    },

    handleFilterResult(value) {
      this.searchFilter = value;
    },

    handleDashboardFilter(value) {
      this.dashboardSearchFilter = value;
    },

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-radio-style input[type="checkbox"] {
    appearance: none;
    border: 2px solid #ccc;
    border-radius: 50%;
    width: 1em;
    height: 1em;
    position: relative;
    cursor: pointer;
  }

  .custom-radio-style input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 0.25em;
    left: 0.25em;
    width: 0.5em;
    height: 0.5em;
    background-color: #007bff;
    border-radius: 50%;
  }
}


.radio-checkbox {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background-color: white;
  position: relative;
}

.radio-checkbox:not(:disabled) {
  cursor: pointer;
}

.radio-checkbox:disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
  border-color: #9ca3af;
}

.radio-checkbox:checked {
  background-color: white;
  border-color: #3b82f6;
}

.radio-checkbox:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #3b82f6;
  border-radius: 50%;
}
</style>
